export default __webpack_public_path__ + "static/media/arrow_orange.a4473966.svg";